import React from "react";
import Button from "react-bootstrap/Button";
import { Plus, Minus, Clock, Trash2 } from "lucide-react";
import Card from "react-bootstrap/Card";
import "../../App.css";
import style from "./Items.module.scss";
import veg from "../../Assets/vegicon.jpeg";
import nonveg from "../../Assets/nonvegicon.png";
import productSilhouette from "../../Assets/product-silhouette.png";
import Badge from 'react-bootstrap/Badge';
/**
 * Item Component
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Object} props.item - The item details.
 * @param {string | number} props.item.id - Unique identifier of the item.
 * @param {string} props.item.name - Name of the item.
 * @param {string} props.item.description - Short description of the item.
 * @param {number} props.item.price - Price of the item.
 * @param {number} props.quantity - Current quantity of the item in the cart.
 * @param {function} props.updateQuantity - Function to update the quantity of the item.
 * @returns {JSX.Element} The rendered item cards component.
 * @author - Susovan Mishra ; susovanm@ovaku.in
 */
function Items({addedOrder, setAddedOrder, item, quantity, updateQuantity, selectedCategory, setItemQuantity }) {
  const handleKeyDown = (e) => {
    if (e.key === "+" || e.key === "Add") {
      updateQuantity(item._id, 1);
    } else if (e.key === "-" || e.key === "Subtract") {
      updateQuantity(item._id, -1);
    }
  }
  return (
    <div style={{userSelect: 'none'}} onKeyDown={handleKeyDown} onClick={(e) => {
      if (!addedOrder) {
        e.stopPropagation();
        updateQuantity(item._id, 1);
      }
    }}
     className="">
      {/* Card to display item details */}
      <Card
        className={`${style.CardDiv} shadow-sm rounded-4 item-card m-3 px-2 h-100`}
      >
        <Card.Body className="d-flex flex-column justify-content-between h-100">
          <div
            className={`${style.containDiv} d-flex gap-4 align-items-start w-100`}
          >
            {/* Item Image */}
            <div className={style.cardImageContainer}>
              <img
                src={item.imageUrl || productSilhouette}
                alt="Item"
                className={`${style.imageStyle} rounded`}
                onError={(e) => {
                  e.target.src = productSilhouette;
                }}
              />
            </div>
            {/* Text and Quantity Controls */}
            <div className="d-flex flex-column justify-content-between flex-grow-1 w-100">
              <div className="w-100">
                <div className="d-flex justify-content-between">
                <img
                  style={{ position: "relative" }}
                  height={15}
                  width={15}
                  src={item.veg ? veg : nonveg}
                  alt=""
                />
                  <Badge bg="warning" text="dark">
                    {item.stockQuantity} left
                  </Badge>
                </div>

                <h3 className="h5 mb-1">{item.name}</h3>
                <p className="text-muted mb-2">{item.description}</p>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-2">
                <div className="h5 text-primary mb-0">₹{item.price}</div>
                {
                  !quantity ? (<Button className="btn-sm" onClick={(e) =>{e.stopPropagation(); updateQuantity(item._id, 1)}}><Plus size={18}/>Add Item</Button>) : (
                    <div className={`${style.buttonContainer} d-flex align-items-center justify-content-end`}>
                      {
                        quantity === 1 || quantity === null || NaN ? (
                          <Button
                          disabled={addedOrder}
                          variant="primary"
                          className={`${style.IncreaseDecreaseButton} p-2 d-flex align-items-center justify-content-end`}
                          onClick={(e) =>{e.stopPropagation(); updateQuantity(item._id, -1)}}
                        >
                          <Trash2 color="red" size={50} />
                        </Button>
                        ) : (
                          <Button
                          variant="primary"
                          disabled={addedOrder}
                          className={`${style.IncreaseDecreaseButton} p-2 d-flex align-items-center justify-content-end`}
                          onClick={(e) =>{e.stopPropagation(); updateQuantity(item._id, -1)}}
                        >
                          <Minus color="blue" size={50} />
                        </Button>
                        )
                      }
                    <span
                      className={`${style.ItemQuantity} fw-medium mx-2`}
                    >
                    <input
                      value={quantity === 0 ? '' : quantity}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow user to clear input temporarily
                        if (value === '') {
                          updateQuantity(item._id, -quantity); // remove all
                          return;
                        }

                        const numValue = parseInt(value, 10);

                        if (!isNaN(numValue)) {
                          const validatedValue = Math.min(
                            Math.max(0, numValue),
                            item.stockQuantity
                          );

                          updateQuantity(item._id, validatedValue - quantity);
                        }
                      }}
                      className={`${style.NumberInput}`}
                      type="number"
                      id="quantity"
                      name="quantity"
                      min="0"
                    />
                    </span>
                    <Button
                      variant="primary"
                      className={`${style.IncreaseDecreaseButton} p-2 d-flex align-items-center justify-content-center`}
                      onClick={(e) => {e.stopPropagation(); updateQuantity(item._id, 1)}}
                    >
                      <Plus color="blue" size={40} />
                    </Button>
                  </div>
                  )
                }


              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Items;
